module.exports = __webpack_public_path__ + "img/3.1.85bc87cb.png";